const to_display_time = (val: number) => {
  const hour = Math.floor(val / 3600)
  let hour_str
  if (hour < 10) {
    hour_str = `0${hour}`
  } else {
    hour_str = String(hour)
  }

  const minute = Math.floor((val - (hour * 3600)) / 60)
  let minute_str
  if (minute < 10) {
    minute_str = `0${minute}`
  } else {
    minute_str = String(minute)
  }
  return `${hour_str}:${minute_str}`
}

const buildPieChartOptions = () => ({
  labels: [""],
  colors: [""],
  dataLabels: {
    enabled: true,
    style: {
      fontSize: '16px',
      fontWeight: "normal",
    },
    formatter: (val: string, opt: { w: { globals: { series: { [x: string]: string } } }; seriesIndex: string | number }) => {
      const par = Number(parseFloat(val).toFixed(0))
      if (par <= 5) {
        return ""
      }
      const time = parseInt(opt.w.globals.series[opt.seriesIndex], 10)
      const hour = Math.floor(time / 3600)
      const minute = Math.floor((time - (hour * 3600)) / 60)
      let str
      if (minute < 10) {
        str = `0${minute}`
      } else {
        str = String(minute)
      }

      return [`${par.toFixed(0)}%`, `(${hour}:${str})`]
    },
  },
  legend: {
    show: false,
  },
  tooltip: {
    enabled: true,
    y: {
      formatter: (val: number) => to_display_time(val),
    },
  },
  plotOptions: {
    pie: {
      expandOnClick: true,
    },
  },
  states: {
    hover: {
      filter: {
        type: 'lighten',
      },
    },
    active: {
      filter: {
        type: 'darken',
      },
    },
  },
})

export const nowOptions = buildPieChartOptions()
export const pastOptions = buildPieChartOptions()
